import React from "react";


import { formatDateLocalTZ } from "utils/utils";
import { DATE_FORMAT_WITH_BITWISEOR} from "constants/globalConstants";

import TooltipLabelWithEllipsis from "components/TooltipLabelWithEllipsis";

import AlertTriangle from "../../assets/Alarms/alert-triangle-grey.svg";

import "./index.scss";

const AlarmCard = ({ sysName, alarmId, description, timestamp, onClick, isToShowSystemName }) => (
    <>
      <div className="cardContainer padding10 custom-alarmcard" onClick={onClick}>
        <div>
          <div className="flex-ai-center">
            <img className="margin-right-5" src={AlertTriangle} alt="alert-triangle" />
            <span className={isToShowSystemName ? "alarm-card__title" : "headerTealText"}>{alarmId}</span>
          </div>
          <div className="bodySecondaryHeadingText padding-bottom-16 padding-top-16">
            {formatDateLocalTZ(timestamp, DATE_FORMAT_WITH_BITWISEOR)}
          </div>
          {isToShowSystemName && <TooltipLabelWithEllipsis label={sysName} />}
          <TooltipLabelWithEllipsis label={description} customClass="bodySecondaryHeadingText" />
        </div>
      </div>
    </>
  );

export default AlarmCard;

AlarmCard.defaultProps = {
  isToShowSystemName: false
};
